<template>
    <div
        class="modal"
        tabindex="-1"
    >
        <div class="modal-dialog modal-dialog-centered modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title text-center">
                        {{ isEdit ? 'Edit' : 'Create' }} Expense
                    </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body bg-light">
                    <fieldset>

                        <div class="row" v-if="isEdit && expense?.driver">
                            <div class="col-12">
                                <AdminBlock>
                                    <p class="mb-0">
                                        <strong>
                                            Driver:
                                        </strong>
                                        <a :href="driverLink">
                                          {{ expense.driver ? expense.driver.name : 'N/A' }}
                                        </a>
                                    </p>
                                </AdminBlock>
                            </div>
                        </div>

                        <div class="row" v-else>
                            <div class="col-12">
                                <AdminBlock>
                                    <MovementSelect
                                        v-model="selectedMovement"
                                        :movement="movements[0]"
                                        :job="job"
                                        remove-margin
                                        required
                                        @update-movement="updateMovement"
                                    />
                                </AdminBlock>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-6">
                                <AdminBlock
                                    title="Expense"
                                >

                                    <InputTextField
                                        name="Label"
                                        label="Label"
                                        placeholder="Label"
                                        required
                                        v-model="expenseLabel"
                                    />

                                    <InputTextField
                                        v-if="!creatingFuel"
                                        name="reference"
                                        label="Reference (Optional)"
                                        placeholder="Reference"
                                        v-model="reference"
                                    />

                                    <InputNumberField
                                        name="fuel"
                                        label="Fuel (Optional)"
                                        placeholder="Fuel"
                                        append="Litres"
                                        v-model="fuel"
                                    />

                                    <div class="">
                                        <div class="mb-2">
                                            <input
                                                v-model="evidenceReceived"
                                                class="me-2"
                                                type="checkbox"
                                                name="evidence_received"
                                                :id="evidenceReceivedId"
                                            />
                                            <label :for="evidenceReceivedId">
                                                <strong>
                                                    Evidence Received (If assigned to Driver)
                                                </strong>
                                            </label>
                                        </div>

                                        <div>
                                            <input
                                                v-model="rechargeClient"
                                                class="me-2"
                                                type="checkbox"
                                                name="recharge_client"
                                                :id="rechargeClientId"
                                            />
                                            <label :for="rechargeClientId">
                                                <strong>
                                                    Recharge Client
                                                </strong>
                                            </label>
                                        </div>
                                    </div>

                                </AdminBlock>

                                <AdminBlock
                                    title="Driver"
                                    class="mb-0"
                                >
                                    <p>
                                        If the Expense was incurred by a Driver and needs paying back to them, please select them below.
                                    </p>
                                    <DriverSelect
                                        :driver="selectedDriver"
                                        required
                                        remove-margin
                                        @update-driver="updateDriver"
                                    />
                                </AdminBlock>
                            </div>

                            <div class="col-lg-6">
                                <AdminBlock
                                    title="Cost"
                                >
                                    <div class="mb-4">
                                        <label for="">
                                            <strong>
                                                Payment Method
                                            </strong>
                                            <span class="text-danger">*</span>
                                        </label>

                                        <VSelect
                                            v-model="selectedPaymentMethod"
                                            :options="[
                                                'Cash',
                                                'Card',
                                                'By Admin'
                                            ]"
                                            placeholder="Payment Method"
                                            required
                                        />
                                    </div>

                                    <!-- We're not doing this just yet -->
                                    <p v-show="false">
                                        If you complete the Total and either the Price or VAT, the remaining field will be automatically filled.
                                    </p>

                                    <div v-if="isCardPayment" class="mb-4">
                                        <label>
                                            <strong>
                                                Own Card
                                            </strong>
                                        </label>
                                        <div>
                                            <input type="radio" class="me-1" id="ownCardYes" :value="true" v-model="ownCard" name="ownCard" />
                                            <label for="ownCardYes" class="me-3">Yes</label>
                                            <input type="radio" class="me-1" id="ownCardNo" :value="false" v-model="ownCard" name="ownCard" />
                                            <label for="ownCardNo">No</label>
                                        </div>

                                        <div v-if="ownCard" class="mt-4">
                                            <label for="fuelCardSelect"><strong>Select Fuel Card</strong></label>
                                            <template v-if="driverFuelCards.length > 0">
                                                <select id="fuelCardSelect" v-model="selectedFuelCardId" class="form-select">
                                                    <option v-for="card in driverFuelCards" :key="card.id" :value="card.id" :selected="selectedFuelCardId === card.id">
                                                        {{ card.card_number?.slice(-6) }}
                                                    </option>
                                                </select>
                                            </template>
                                            <div v-else class="text-danger mt-2">No Fuel Cards assigned to Driver</div>
                                        </div>
                                        <div v-else class="mt-4">
                                            <label for="otherCardText"><strong>Card Details</strong></label>
                                            <input id="otherCardText" type="text" v-model="otherCardText" class="form-control" placeholder="Enter the last 6 card numbers" maxlength="6" />
                                        </div>
                                    </div>

                                    <div class="mb-4">
                                        <label for="expenseDate"><strong>Date</strong></label>
                                        <input type="date" id="expenseDate" v-model="expenseDate" ref="expenseDateInput" class="form-control js-flatpickers" />
                                        <div class="row mt-4">
                                            <div class="col-6">
                                                <label for="expenseHour" class="form-label mb-0">
                                                    <strong>
                                                        Hour
                                                    </strong>
                                                </label>
                                                <select id="expenseHour" v-model="expenseHour" class="form-select">
                                                    <option v-for="h in 24" :key="h" :value="pad(h-1)">{{ pad(h-1) }}</option>
                                                </select>
                                            </div>
                                            <div class="col-6">
                                                <label for="expenseMinute" class="form-label mb-0">
                                                    <strong>
                                                        Minute
                                                    </strong>
                                                </label>
                                                <select id="expenseMinute" v-model="expenseMinute" class="form-select">
                                                    <option v-for="m in 60" :key="m" :value="pad(m-1)">{{ pad(m-1) }}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <InputTextField
                                        v-if="!creatingFuel"
                                        name="price"
                                        label="Price (Optional)"
                                        placeholder="0.00"
                                        prepend="£"
                                        v-model="price"
                                    />

                                    <InputTextField
                                        v-if="!creatingFuel"
                                        name="vat"
                                        label="VAT Amount (Optional)"
                                        placeholder="0.00"
                                        prepend="£"
                                        v-model="vat"
                                    />

                                    <InputTextField
                                        name="total"
                                        label="Total (Optional if fuel)"
                                        placeholder="0.00"
                                        prepend="£"
                                        v-model="total"
                                        remove-margin
                                    />

                                </AdminBlock>

                                <AdminBlock
                                    title="Images"
                                    class="mb-0"
                                >

                                    <p class="mb-0">
                                        Please upload your receipts where possible
                                    </p>

                                    <FileUpload
                                        :file-upload-route="getFileUploadRoute()"
                                        name="receipt_file_signature"
                                        ref="fileUpload"
                                        no-margin
                                        multiple
                                        @file-uploaded="handleFileUploaded"
                                    />

                                </AdminBlock>
                            </div>
                        </div>

                        <template v-if="files.length > 0">
                            <AdminBlock class="mb-2 mt-4"  :title="'File' + (files.length > 1 ? 's' : '')">
                                <table class="table table-striped mb-0">
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th style="width: 115px;">Date</th>
                                            <th style="width: 150px;">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="file in files" :key="file.id">
                                            <td class="align-middle">
                                                <a :href="getFileLink(file)" class="d-flex align-items-center"
                                                   target="_blank">
                                                    <i class="fa fa-file me-2"></i>
                                                    {{ file.name }}
                                                </a>
                                            </td>
                                            <td class="align-middle">
                                                {{ new Date(file.created_at).toLocaleDateString() }}
                                            </td>
                                            <td class="align-middle">
                                                <a :href="getFileLink(file)" class="btn btn-secondary btn-sm me-2" target="_blank">
                                                    View
                                                </a>
                                                <button class="btn btn-danger btn-sm" type="button"
                                                        @click="deleteFile(file)">
                                                    Delete
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </AdminBlock>
                        </template>
                    </fieldset>
                </div>

                <div class="modal-footer">
                    <button type="button"
                            class="btn btn-secondary"
                            data-bs-dismiss="modal">Close</button>

                    <button type="button" class="btn btn-primary" @click="createNewExpense()" >
                        {{ isEdit ? 'Update' : 'Save' }}
                    </button>
                </div>

            </div>
        </div>
    </div>
</template>

<script setup>

import axios from 'axios';
import VSelect from 'vue-select';
import {DateTime} from "luxon";
import {computed, onMounted, ref, useId, watch} from 'vue';
import {errorAlert, successAlert} from "@/utils";
import AdminBlock from '@/components/movements/components/AdminBlock.vue';
import InputTextField from '@/components/movements/components/InputTextField.vue';
import DriverSelect from '@/components/movements/components/DriverSelect.vue';
import FileUpload from "@/components/movements/components/FileUpload.vue";
import MovementSelect from "@/components/movements/components/MovementSelect.vue";
import InputNumberField from "@/components/movements/components/InputNumberField.vue";

const props = defineProps({
    movements: {
        type: Array,
        default: () => [],
    },
    job: {
        type: Object,
        default: () => ({}),
    },
    expense: {
        type: Object,
        default: () => ({}),
    },
    creatingFuel: {
        type: Boolean,
        default: false,
    }
})

const emit = defineEmits(['expense-created', 'file-deleted']);

const expenseLabel = ref('');
const reference = ref('');
const fuel = ref(null);

const evidenceReceived = ref(false);
const rechargeClient = ref(false);

const ownCard = ref(null);
const selectedFuelCardId = ref(null);
const otherCardText = ref('');
const isCardPayment = computed(() => selectedPaymentMethod.value === 'Card');
const driverFuelCards = ref([]);

const expenseDate = ref('');
const expenseDateInput = ref(null);
const expenseHour = ref('');
const expenseMinute = ref('');

const selectedMovement = ref(null);
const selectedDriver = ref(null);
const selectedPaymentMethod = ref('');

const price = ref(null);
const vat = ref(null);
const total = ref(null);

const fileUpload = ref(null);
const fileInternalSignatures = ref([]);

const evidenceReceivedId = useId() + '_evidence_received';
const rechargeClientId = useId() + '_recharge_client';

const isEdit = computed(() => {
    return props.expense?.id;
});

const getFileLink = (file) => {
    if (!file) {
        return '';
    }
    return route('movements.jobs.expenses.files.show', {file: file.id});
}

const cardBelongsToDriver = computed(() => {
    if (props.expense?.id && props.expense?.fuel_card_id && selectedDriver.value) {
            const card = driverFuelCards.value.find(c => c.id === props.expense.fuel_card_id);
            return !!card;
    }
    return false;
});

function pad(num) {
    return String(num).padStart(2, '0');
}

const updateMovement = (value) => {
    selectedMovement.value = value;
    if (value?.driver) {
        selectedDriver.value = value.driver;
    }
};

const getFileUploadRoute = () => {
    return route('api.movements.expenses.get-upload-url');
}

const handleFileUploaded = (signatures) => {
    fileInternalSignatures.value = signatures;
}

const createNewExpense = () => {

    if (!isEdit.value && (!fileInternalSignatures.value || fileInternalSignatures.value.length === 0)) {
        if (!confirm('Do you want to continue without adding photo evidence?')) {
            return;
        }
    }

    const data = {
        movement_id: selectedMovement.value?.id ?? null,
        driver_id: selectedDriver.value?.id ?? null,
        label: expenseLabel.value,

        payment_method: selectedPaymentMethod.value,

        fuel_card_id: isCardPayment.value && ownCard.value ? selectedFuelCardId.value : null,
        other_card_text: isCardPayment.value && !ownCard.value ? otherCardText.value : null,

        date: expenseDate.value || null,
        hour: expenseHour.value || null,
        minute: expenseMinute.value || null,

        evidence_received: evidenceReceived.value,
        recharge_client: rechargeClient.value,

        reference: reference.value || null,
        fuel: fuel.value ?? null,
        price: price.value ?? null,
        vat: vat.value ?? null,
        total: total.value ?? null,

        receipt_file_signature: fileInternalSignatures.value,
    };

    const url = isEdit.value
        ? route('api.movements.expenses.update', { expense: props.expense.id })
        : route('api.movements.expenses.store');

    const method = isEdit.value ? 'put' : 'post';

    axios[method]( url, data, {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        }
    })
        .then(response => {

            emit('expense-created', response.data.expense);

            fileUpload.value?.reset();
            fileInternalSignatures.value = [];

            successAlert(isEdit.value ? 'Expense Updated!' : 'Expense Created', 'Success');

            window.jQuery('.modal-header .btn-close').click();
        })
        .catch( errors => {
            const title = isEdit.value ? 'Error Updating Expense' : 'Error Creating Expense';
            errorAlert(errors, title);
        });
}

/*
 * Because we only have the selected Driver to go off,
 * When that changes we fetch their fuel cards from the API
 * Fuel Cards are still brought in with the API by default
 * But this doesn't accommodate the driver changing
 */
const getFuelCardsForDriver = (driver) => {
    if (!driver?.id) {
        driverFuelCards.value = [];
        return;
    }

    axios.get(route('api.movements.drivers.fuel-cards', { driver: driver.id }))
        .then(response => {
            driverFuelCards.value = response.data;
            if (!selectedFuelCardId.value) {
                selectedFuelCardId.value = driverFuelCards.value.length > 0 ? driverFuelCards.value[0].id : null;
            }
        })
        .catch(errors => {
            errorAlert(errors, 'Error Fetching Fuel Cards for Driver');
        });
}

/**
 * Resets all the state variables to their default values
 * Used when opening the Modal for creating a new Expense
 *
 * We DO NOT reset the Drivers and their Fuel Cards because this breaks the loading
 */
const resetState = () => {
    expenseLabel.value = '';
    reference.value = '';
    fuel.value = null;

    evidenceReceived.value = false;
    rechargeClient.value = false;
    selectedPaymentMethod.value = '';

    ownCard.value = null;
    selectedFuelCardId.value = null;
    otherCardText.value = '';

    const now = DateTime.local();
    expenseDate.value = now.toFormat('yyyy-MM-dd');
    expenseHour.value = pad(now.hour);
    expenseMinute.value = pad(now.minute);

    // selectedMovement.value = null;
    // selectedDriver.value = null;

    price.value = null;
    vat.value = null;
    total.value = null;

    fileInternalSignatures.value = [];
    fileUpload.value?.reset();
}

defineExpose({
    resetState,
});

const updateDriver = (value) => {
    selectedDriver.value = value
}

const driverLink = computed(() => {
    return selectedDriver.value ? route('movements.drivers.show', { driver: selectedDriver.value.id }) : '#';
});

const deleteFile = (file) => {

    if (!confirm('Are you sure you want to delete this file?')) {
        return;
    }

    axios.delete(route('api.movements.expenses.files.destroy', {file: file.id}))
        .then((response) => {
            successAlert('File Deleted', 'Success');
            emit('file-deleted', response.data.expense);
        })
        .catch((error) => {
            errorAlert(error, "Error Deleting File");
        });
}

const files = computed(() => props.expense?.files ?? []);

/*
 * Because we use the same Modal for creating and editing,
 * This watch will populate all the fields when the expense prop changes
 */
watch(() => props.expense, (newExpense) => {

    if (!newExpense || !newExpense.id) {
        const now = DateTime.local();
        expenseDate.value = now.toFormat('yyyy-MM-dd');
        expenseHour.value = pad(now.hour);
        expenseMinute.value = pad(now.minute);
        return;
    }

    expenseLabel.value = newExpense?.label ??  '';
    reference.value = newExpense?.reference ??  '';
    fuel.value = newExpense?.fuel ?? null;

    evidenceReceived.value = !!newExpense?.evidence_received || false;
    rechargeClient.value = !!newExpense?.recharge_client || false;
    selectedPaymentMethod.value = newExpense?.payment_method || '';

    if (selectedPaymentMethod.value === 'Card') {
        ownCard.value = cardBelongsToDriver.value;
        if (ownCard.value) {
            const card = driverFuelCards.value.find(c => c.id === newExpense.fuel_card_id);
            selectedFuelCardId.value = card?.id ?? null;
        } else {
            selectedFuelCardId.value = null;
            otherCardText.value = newExpense?.fuel_card?.card_number?.slice(-6) || '';
        }
    } else {
        ownCard.value = null;
        selectedFuelCardId.value = null;
    }

    expenseDate.value = newExpense?.date || '';

    if (newExpense?.time) {
        const parsedTime = DateTime.fromFormat(newExpense.time, 'HH:mm:ss');
        if (parsedTime.isValid) {
            expenseHour.value = pad(parsedTime.hour);
            expenseMinute.value = pad(parsedTime.minute);
        }
    } else {
        expenseHour.value = '';
        expenseMinute.value = '';
    }

    price.value = newExpense?.price || null;
    vat.value = newExpense?.vat || null;
    total.value = newExpense?.total || null;

    selectedDriver.value = newExpense?.driver || null;
    selectedMovement.value = props.movements.find(movement => movement.id === newExpense?.movement_id ) || null;
}, );

/*
 * Because we only have the selected Driver to go off,
 * When that changes we fetch their fuel cards from the API
 */
watch(() => selectedDriver.value, (newDriver) => {
    getFuelCardsForDriver(newDriver)
}, { immediate: true });

const cardBackup = ref(null);

/*
 * We want to make sure that when ownCard changes we empty the other value
 * so that validation works correctly.
 *
 * We then repopulate the data var if switching back to 'yes' from 'no'
 */
watch(() => ownCard.value, (newCard) => {
    if (newCard) {
        otherCardText.value = '';
        if (selectedFuelCardId.value == null && cardBackup.value != null) {
            selectedFuelCardId.value = cardBackup.value;
        }
    } else {
        cardBackup.value = selectedFuelCardId.value;
        selectedFuelCardId.value = null;
    }
})

onMounted(() => {
    /**
     * Set date to today if creating new Expense
     * otherwise the dates should be set to the expense's date
     */
    if (!props.expense?.id) {

        expenseDate.value = DateTime.local().toFormat('yyyy-MM-dd');

        const now = DateTime.local();

        expenseHour.value = pad(now.hour);
        expenseMinute.value = pad(now.minute);
    }
});

</script>
